import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from '@/contexts/AuthContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import ErrorBoundary from '@/components/common/ErrorBoundary'
import ProtectedRoute from '@/components/auth/ProtectedRoute'
import AppLayout from '@/components/layout/AppLayout'
import AtendentesPage from '@/pages/AtendentesPage'
import CreditosPage from '@/pages/CreditosPage'
import FilasPage from '@/pages/FilasPage'
import HomePage from '@/pages/HomePage'
import LoginPage from '@/pages/LoginPage'
import NumerosPage from '@/pages/NumerosPage'
import PlanCheckoutSummaryPage from '@/pages/PlanCheckoutSummaryPage'
import PlanosPage from '@/pages/PlanosPage'
import RamaisPage from '@/pages/RamaisPage'
import RegisterPage from '@/pages/RegisterPage'

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<HomePage />} />
                <Route path="/ramais" element={<RamaisPage />} />
                <Route path="/planos" element={<PlanosPage />} />
                <Route path="/planos/resumo" element={<PlanCheckoutSummaryPage />} />
                <Route path="/creditos" element={<CreditosPage />} />
                <Route path="/numeros" element={<NumerosPage />} />
                <Route path="/filas" element={<FilasPage />} />
                <Route path="/atendentes" element={<AtendentesPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
